<template>
  <div class="login-container">
    <el-form :model="loginForm" :rules="fieldRules" ref="loginForm" label-position="left" label-width="0px"
      class="demo-ruleForm login-form">
      <span class="tool-bar">
        <!-- 主题切换
        <theme-picker style="float:right;" class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>-->
      </span>
      <h2 class="title" style="padding-left:22px;">驾驶员培训管理平台登录</h2>
      <el-form-item prop="username">
        <el-input type="text" v-model="loginForm.username" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="loginForm.password" placeholder="密码" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-col :span="12">
          <el-form-item prop="captcha">
            <el-input type="test" v-model="loginForm.captcha" auto-complete="off" placeholder="验证码, 单击图片刷新"
              style="width: 100%;">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="1">&nbsp;</el-col>
        <el-col :span="11">
          <el-form-item>
            <img style="width: 100%;" class="pointer" :src="loginForm.src" @click="refreshCaptcha">
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item style="margin-top:-20px">
        <div class="toindexbox">
          <el-checkbox v-model="checked">记住密码</el-checkbox>
          <el-link type="primary" @click="$router.push('/')">去首页</el-link>
        </div>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:46%;" @click.native.prevent="reset">重 置</el-button>
        <el-button type="primary" style="width:46%;" @click.native.prevent="login" :loading="loading">登 录</el-button>
      </el-form-item>
      <div class="f-beian">
        &copy;2022 – 2032<a href="https://beian.miit.gov.cn/" target="_blank">赣ICP备2022002627号</a>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cookies from "js-cookie"
import ThemePicker from "@/components/ThemePicker"

export default {
  name: 'Login',
  components: {
    ThemePicker
  },
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        src: ''
      },
      fieldRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      checked: true,
      userPassword: {}
    }
  },
  created() {
    this.rememberPassword()

    // 单点登录
    const { href } = window.location;
    this.sso = this.$$util.strUtil.getParamsByUrl(href);
    console.log('>>>>>>>>>:::::::::::', this.sso)
    if (this.sso && this.sso.type === 'sso') {
      const params = Object.assign({}, this.sso, { type: undefined })
      this.$api.login.sso(params).then(res => {
        console.log('单点登录：', res)
        this.$store.commit('SET_USER', res.data);
        this.$store.commit('menuRouteLoaded', false); // 要求重新加载导航菜单
        this.$router.push('/');  // 登录成功，跳转到主页
      })
    }
  },
  mounted() {
    this.refreshCaptcha();
    this.initLoginEvent();
    this.rememberPassword()
  },
  computed: {
    ...mapState({
      themeColor: state => state.app.themeColor
    })
  },
  methods: {
    /**
     * 登录事件初始化
     */
    initLoginEvent() {
      window.onkeydown = (e) => {
        // console.log('>>>>', e)
        const event = e || window.event;
        const code = event.keyCode || event.which || event.charCode;
        if (code === 13) {
          this.login();
        }
      };
    },
    // 初始化记住用户密码
    rememberPassword() {
      if (Cookies.get('userPassword')) {
        let userPassword = JSON.parse(Cookies.get('userPassword'))
        this.loginForm.password = userPassword.password
        this.loginForm.username = userPassword.username
      }
    },
    /**
     * 登录
     */
    login() {
      this.loading = true
      let userInfo = {
        username: this.loginForm.username,
        password: this.loginForm.password,
        captcha: this.loginForm.captcha,
        uuid: this.loginForm.uuid
      }
      const userPassword = Object.assign({}, { username: this.loginForm.username, password: this.loginForm.password })
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$api.login.login(userInfo).then((res) => {
            const {userCenterInfo} = res.data;
            if (this.checked) {
              Cookies.set('userPassword', userPassword, { expires: 14, path: '' })
            }
            console.log('登录:', res)
            this.$store.commit('SET_USER', res.data);
            this.$store.commit('menuRouteLoaded', false) // 重新加载导航菜单
            // 如果登录用户有单点登录地址，则开启用户中心心跳
            if (userCenterInfo && userCenterInfo.platformSso.length) {
              console.log('>>>>>>>>>>><<<<<<<<<<<<<<<')
              const {userId, loginRecord} = userCenterInfo;
              this.$$utils.serviceUtil.startUserCenterHeartBeat({userId, loginRecord});
            }
            this.$router.push('/')  // 登录成功，跳转到主页
            this.loading = false
          }).catch((res) => {
            this.$message({
              message: res.message,
              type: 'error'
            })
            this.refreshCaptcha();
          });
        }
      })
      this.loading = false;
    },
    refreshCaptcha: function () {
      this.$api.login.getCodeImg().then((res) => {
        this.loginForm.src = "data:image/gif;base64," + res.data.img;
        this.loginForm.uuid = res.data.uuid
      })
    },
    reset() {
      this.$refs.loginForm.resetFields()
    },
    // 切换主题
    onThemeChange: function (themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    },
  },

}
</script>

<style lang="scss" scoped>
.login-container {
  background-image: url("../assets/backgroud2.png");
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  .login-form {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 200px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    .title {
      margin: 0px auto 30px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
}

.f-beian {
  font-size: 12px;
  text-align: center;

  a {
    color: #333;
  }
}
.toindexbox{ display: flex; justify-content: space-between;}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue